import { Config } from 'src/apis/config'
import { MutationTree } from 'vuex'
import { ConfigStateInterface } from './state'
import types from './types'

const mutation: MutationTree<ConfigStateInterface> = {
  [types.SET_CONFIG](state, params: Config) {
    state.id = params.id
    state.name = params.name
    state.slug = params.slug
    state.description = params.description
    state.image = params.image
    state.endpoint = params.endpoint || null
  },
}

export default mutation
